if (!customElements.get('set-catalog')) {
  customElements.define('set-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const filters = this.querySelector('.sets-filters');
      const cards = [...this.querySelectorAll('.set-card[data-set-groups]')];
      const count = this.querySelector('[data-set-count]');
      if (!filters || !cards.length) return;
      filters.hidden = false;
      filters.addEventListener('click', event => {
        const button = event.target.closest('button[data-set-filter]');
        if (!button) return;
        const selected = button.dataset.setFilter;
        let visible = 0;
        cards.forEach(card => {
          card.hidden = selected !== 'all' && !card.dataset.setGroups.split(' ').includes(selected);
          if (!card.hidden) visible++;
        });
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        if (count) count.textContent = `${visible} ${visible === 1 ? this.dataset.countSingular : this.dataset.countLabel}`;
      });
    }
  });
}
